
import { Component, EventEmitter, Output, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'kudos-request',
    templateUrl: './kudos-request.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule
]
})
export class KudosRequestComponent {

    @Output() onRequestKudos = new EventEmitter<any>();

    constructor() {}

    createKudos (){
        this.onRequestKudos.emit();
    }

}